import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

import { getAssistCountries } from '@shared/services/services';
import { toReadableDate, calculateInclusiveDays } from '@shared/helpers';

import InfoValueRow from '@shared/components/InfoValueRow';

const CoverageDetails = ({ storagePassengers }) => {
  const [country, setCountry] = useState('');

  const fetchCountries = async () => {
    const result = await getAssistCountries();
    const country = result?.find(el => el.code == storagePassengers?.pais);
    setCountry(country?.description);
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  const gridTemplateColumns = {
    xs: '50% 50%',
    md: '40% 60%',
    lg: '50% 50%',
    xl: '50% 50%',
  };

  return (
    <Box>
      <Typography
        sx={{
          color: '#000',
          fontSize: { xs: '18px', sm: '20px' },
          fontWeight: 700,
          textAlign: 'left',
          lineHeight: 1,
        }}
      >
        Descripción de la cobertura
      </Typography>

      <Box
        sx={{
          mx: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          mt: 2,
        }}
      >
        <InfoValueRow
          label="Tiempo cubierto:"
          gridTemplateColumns={gridTemplateColumns}
          value={`${calculateInclusiveDays(
            storagePassengers?.start_date,
            storagePassengers?.end_date
          )} Días`}
        />
        <InfoValueRow
          label="Emitido en:"
          gridTemplateColumns={gridTemplateColumns}
          value={country}
        />
        <InfoValueRow
          label="Destino:"
          gridTemplateColumns={gridTemplateColumns}
          value={storagePassengers?.destination_description}
        />
        <InfoValueRow
          label="Partida:"
          gridTemplateColumns={gridTemplateColumns}
          value={toReadableDate(storagePassengers?.start_date)}
        />
        <InfoValueRow
          label="Regreso:"
          gridTemplateColumns={gridTemplateColumns}
          value={toReadableDate(storagePassengers?.end_date)}
        />
      </Box>
    </Box>
  );
};

export default CoverageDetails;
